import React from 'react';
import { IOrder } from '@/interfaces/order';
import TemplateFooter from './components/template-footer';
import TemplateHeader from './components/template-header';
import TemplateOrderInfo from './components/template-order-info';
import TemplateOrderInfoSecond from './components/template-order-info-second';
import TemplateOrderInfoItem from './components/template-order-info-item';

interface IProps {
  data: IOrder;
}

const TM16 = ({ data }: IProps) => {
  if ((data?.orderItems?.length || 0) > 5) {
    return (
      <>
        <div
          style={{
            maxWidth: '209mm',
            minWidth: '209mm',
            minHeight: '296mm',
            maxHeight: '296mm',
            backgroundColor: 'white',
            margin: '0px auto',
            position: 'relative',
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 10,
            paddingBottom: 10,
            pageBreakBefore: 'always',
          }}
        >
          <TemplateHeader
            description=""
            titleEn="PROFORMA INVOICE"
            titleTh=""
            businessUnitLogo={data.businessUnitLogo}
          />
          <TemplateOrderInfo data={data} code={data.ivNo} />
          <TemplateOrderInfoSecond data={data} />
          <TemplateOrderInfoItem
            data={data}
            isShowPrice
            items={data.orderItems}
          />
          <TemplateFooter
            paidInfoTemplate="TM04"
            footerTextLeft="ต้นฉบับ - ORIGINAL"
            footerTextRight="ต้นฉบับ - นำกลับบริษัท"
            referenceNo1={data?.customer?.reference1 || ''}
            referenceNo2={data?.customer?.reference2 || ''}
            amount={data?.summary}
            customerCode={data?.customer?.code || ''}
            ivNo={data?.ivNo}
            showFooter={false}
            isInvoice
            isReceive={false}
            docNo={data?.code}
            page="1/2"
            isMultiPage
          />
        </div>
        <div
          style={{
            maxWidth: '209mm',
            minWidth: '209mm',
            minHeight: '296mm',
            maxHeight: '296mm',
            backgroundColor: 'white',
            margin: '0px auto',
            position: 'relative',
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 10,
            paddingBottom: 10,
            pageBreakBefore: 'always',
          }}
        >
          <TemplateHeader
            description=""
            titleEn="PROFORMA INVOICE"
            titleTh=""
            businessUnitLogo={data.businessUnitLogo}
          />
          <TemplateFooter
            paidInfoTemplate="TM04"
            footerTextLeft="ต้นฉบับ - ORIGINAL"
            footerTextRight="ต้นฉบับ - นำกลับบริษัท"
            referenceNo1={data?.customer?.reference1 || ''}
            referenceNo2={data?.customer?.reference2 || ''}
            amount={data?.summary}
            customerCode={data?.customer?.code || ''}
            ivNo={data?.ivNo}
            showFooter={false}
            isInvoice
            isReceive={false}
            docNo={data?.code}
            page="2/2"
          />
        </div>
      </>
    );
  }
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateHeader
        description=""
        titleEn="PROFORMA INVOICE"
        titleTh=""
        businessUnitLogo={data.businessUnitLogo}
      />
      <TemplateOrderInfo data={data} code={data.ivNo} />
      <TemplateOrderInfoSecond data={data} />
      <TemplateOrderInfoItem data={data} isShowPrice items={data.orderItems} />
      <TemplateFooter
        paidInfoTemplate="TM04"
        footerTextLeft="ต้นฉบับ - ORIGINAL"
        footerTextRight="ต้นฉบับ - นำกลับบริษัท"
        referenceNo1={data?.customer?.reference1 || ''}
        referenceNo2={data?.customer?.reference2 || ''}
        amount={data?.summary}
        customerCode={data?.customer?.code || ''}
        ivNo={data?.ivNo}
        showFooter={false}
        isInvoice
        isReceive={false}
        docNo={data?.code}
      />
    </div>
  );
};

export default TM16;
